import { render } from "./AssetsTypeForm.vue?vue&type=template&id=a7603984"
import script from "./AssetsTypeForm.vue?vue&type=script&lang=js"
export * from "./AssetsTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__